<div class="dynamic-field-container" [class.selected]="config?.selected">
  <div
    class="dynamic-field form-input text-align"
    [formGroup]="group"
    [hidden]="!config?.isFormBuilder && config?.options?.hidden"
  >
    <ups-dynamic-helper-label
      [config]="config"
      [dynamicService]="dynamicService"
    ></ups-dynamic-helper-label>

    <div class="job-search-container" style="position: relative">
      <!-- ===================== SINGLE SELECT ===================== -->
      @if (!config?.options?.isMultiSelect) {
        <kendo-dropdownlist
          #dropdown
          class="k-no-dropdown w-100"
          [attr.name]="config.formControlName"
          [formControlName]="config.formControlName"
          [valuePrimitive]="false"
          [textField]="'Name'"
          [valueField]="'PlantId'"
          [defaultItem]="{ Name: config?.placeholder }"
          [filterable]="true"
          (valueChange)="valueChangeItem($event)"
          search-ex
          [seSearchColumns]="['Name', 'Address', 'City', 'State', 'Client']"
          (seFilterChangeEx)="filterChangeItem($event)"
          [seDebounceFilterChange]="150"
          [seUseCustomLocalFilter]="true"
          [seMinSearchLength]="0"
          [loading]="isLoading"
          [tabindex]="tabindex"
        >
          <!-- Dropdown Item Template -->
          <ng-template kendoDropDownListItemTemplate let-dataItem>
            <div
              style="display: inline-flex"
              [hidden]="dataItem?.Name === config?.placeholder"
            >
              <span>
                <i
                  class="fas fa-star"
                  title="Add/Remove Favorite Facility"
                  [ngStyle]="{
                    color: dataItem.IsUserFavorite ? 'orange' : 'lightgrey',
                  }"
                ></i>
                &nbsp;
              </span>

              <div>
                @if (dataItem.Name) {
                  <span class="job-name link-style">{{ dataItem.Name }}</span>
                }
                @if (dataItem.Address) {
                  <div class="clearBoth">
                    <div style="display: inline-block">
                      {{ dataItem.Address }}
                    </div>
                  </div>
                }

                <div class="clearBoth">
                  <div style="display: inline-block">
                    {{ dataItem.City || 'n/a' }}
                  </div>
                  <div style="display: inline-block">
                    {{ dataItem.State ? ', ' + dataItem.State : '' }}
                  </div>
                  <div style="display: inline-block">
                    {{ dataItem.ZIP ? ' ' + dataItem.ZIP : '' }}
                  </div>
                </div>
              </div>
            </div>
          </ng-template>

          <!-- Selected Value Template -->
          <ng-template kendoDropDownListValueTemplate let-dataItem>
            <div style="display: inline-flex">
              <div kendoTooltip [title]="dataItem?.Name">
                <span class="job-name">{{ dataItem.Name }}</span>
              </div>
            </div>
          </ng-template>
        </kendo-dropdownlist>
      }

      <!-- ===================== MULTI SELECT ===================== -->
      @if (config?.options?.isMultiSelect) {
        <kendo-multiselect
          upsKeepSelectionOnEsc
          [attr.name]="config.formControlName"
          [formControlName]="config.formControlName"
          class="k-no-dropdown w-100"
          [valuePrimitive]="false"
          [textField]="'Name'"
          [valueField]="'PlantID'"
          [placeholder]="config?.placeholder"
          [filterable]="true"
          (valueChange)="multiSelectValueChange($event)"
          search-ex
          [seSearchColumns]="['Name', 'Address', 'City', 'State', 'Client']"
          (seFilterChangeEx)="filterChangeItem($event)"
          [seDebounceFilterChange]="150"
          [seUseCustomLocalFilter]="true"
          [seMinSearchLength]="0"
          [loading]="isLoading"
          [tabindex]="tabindex"
        >
          <!-- MultiSelect Item Template -->
          <ng-template kendoMultiSelectItemTemplate let-dataItem>
            <div
              style="display: inline-flex"
              [hidden]="dataItem?.Name === config?.placeholder"
            >
              <div>
                @if (dataItem.Name) {
                  <span class="job-name link-style">{{ dataItem.Name }}</span>
                }
                @if (dataItem.Address) {
                  <div class="clearBoth">
                    <div style="display: inline-block">
                      {{ dataItem.Address }}
                    </div>
                  </div>
                }

                <div class="clearBoth">
                  <div style="display: inline-block">
                    {{ dataItem.City || 'n/a' }}
                  </div>
                  <div style="display: inline-block">
                    {{ dataItem.State ? ', ' + dataItem.State : '' }}
                  </div>
                  <div style="display: inline-block">
                    {{ dataItem.ZIP ? ' ' + dataItem.ZIP : '' }}
                  </div>
                </div>
              </div>
            </div>
          </ng-template>

          <!-- MultiSelect Value Template -->
          <ng-template kendoMultiSelectValueTemplate let-dataItem>
            <div style="display: inline-flex">
              <div kendoTooltip [title]="dataItem?.Name">
                <span class="job-name">{{ dataItem.Name }}</span>
              </div>
            </div>
          </ng-template>
        </kendo-multiselect>
      }
    </div>
    <ups-dynamic-search-error [show]="searchError"></ups-dynamic-search-error>

    <!-- ===================== FORM BUILDER MASK ===================== -->
    @if (config?.isFormBuilder) {
      <div
        class="form-builder-mask"
        [class.hidden]="config?.options?.hidden"
      ></div>
    }
  </div>

  <!-- ===================== FORM BUILDER OPTIONS ===================== -->
  @if (config?.isFormBuilder) {
    <div class="form-builder-options">
      <i class="fas fa-times ms-3 cursor-pointer c-red" (click)="delete()"></i>
    </div>
  }
</div>
